import React, { useState } from 'react';
import './HomePage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faBullseye } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Header } from '../Componentes/Header';
import { Footer } from '../Componentes/Footer';

 


const HomePage = () => {
  /* ------------------------------
   *  STATE
   * ------------------------------ */
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [sending, setSending] = useState(false);
  const [resposta, setResposta] = useState(null);
  const { executeRecaptcha } = useGoogleReCaptcha();

  /* -----------------------------
   *  HANDLERS
   * ------------------------------ */

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Extra safety – block if privacy not accepted or recaptcha unavailable
    if (!acceptedPrivacy) {
      setResposta('⚠️ É necessário aceitar a Política de Privacidade.');
      return;
    }
    if (!executeRecaptcha) {
      setResposta('Não foi possível inicializar o reCAPTCHA. Tente novamente.');
      return;
    }

    setSending(true);
    setResposta(null);

    try {
      const token = await executeRecaptcha('contact_form');

      const data = {
        fromName: nome,
        replyTo: email,
        message: mensagem,
        recaptchaToken: token,
      };

      const response = await fetch('https://api.meicor.pt/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setResposta('✅ Mensagem enviada com sucesso!');
        setNome('');
        setEmail('');
        setMensagem('');
        setAcceptedPrivacy(false);
      } else {
        const errorData = await response.json();
        setResposta(`Erro ao enviar: ${errorData.error || 'Erro desconhecido.'}`);
      }
    } catch (error) {
      console.error(error);
      setResposta('Falha ao conectar com o servidor.');
    } finally {
      setSending(false);
    }
  };

  /* ------------------------------
   *  RENDER
   * ------------------------------ */

  return (
    <div className="homepage">
      {/* HEADER */}
      <Header></Header>

      {/* SEÇÃO SOBRE */}
      <section id="about" className="section about">
        <h2>Sobre a Meicor</h2>
        <p>
          A Meicor é uma empresa familiar situada em Aveleda, Lousada, que produz cordões para diversos fins.
          Combinamos tradição e inovação para oferecer produtos duráveis e de excelência.
        </p>
      </section>

      {/* SEÇÃO VISÃO & MISSÃO */}
      <section id="vision-mission" className="section vision-mission">
        <h2>Visão &amp; Missão</h2>
        <div className="vision-mission-container">
          <div className="vm-box">
            <div className="vm-icon">
              <FontAwesomeIcon icon={faBullseye} size="3x" />
            </div>
            <h3>Missão</h3>
            <p>
              Na Meicor, pautamo-nos pela tradição e excelência na produção de cordões,
              combinando a experiência familiar com inovação contínua. Promovemos um ambiente
              de trabalho harmonioso e colaborativo, garantindo soluções personalizadas que
              superem as expectativas dos nossos clientes e parceiros.
            </p>
          </div>
          <div className="vm-box">
            <div className="vm-icon">
              <FontAwesomeIcon icon={faEye} size="3x" />
            </div>
            <h3>Visão</h3>
            <p>
              Ser reconhecida como referência no setor de passamanaria, valorizando a herança
              familiar, a sustentabilidade e a confiança. Trabalhamos para crescer de forma responsável,
              mantendo altos padrões de qualidade e fortalecendo parcerias duradouras.
            </p>
          </div>
        </div>
      </section>

      {/* SEÇÃO CONTATO */}
      <section id="contact" className="section contact">
        <h2>Contato</h2>
        <div className="contact-wrapper">
          <div className="contact-info">
            <p>Telefone: <strong>255 912 534</strong></p>
            <p>Telemóvel: <strong>919 937 282</strong></p>
            <p>Email: <strong><a href="mailto:meicor@live.com.pt">meicor@live.com.pt</a></strong></p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <input
              type="text"
              placeholder="Nome"
              required
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
            <input
              type="email"
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <textarea
              placeholder="Mensagem"
              rows="5"
              required
              value={mensagem}
              onChange={(e) => setMensagem(e.target.value)}
            />

            {/* Checkbox de privacidade */}
            <label className="privacy-checkbox">
              <input
                type="checkbox"
                checked={acceptedPrivacy}
                onChange={(e) => setAcceptedPrivacy(e.target.checked)}
                required
              />
              <span>
                Li e aceito a <Link to="/politica-privacidade">Política de Privacidade</Link>
              </span>
            </label>

            <button type="submit" disabled={!acceptedPrivacy || sending}>
              {sending ? 'Enviando…' : 'Enviar'}
            </button>
          </form>
        </div>

        {/* mensagem de retorno */}
        {resposta && <p className="form-response">{resposta}</p>}
      </section>

      {/* SEÇÃO LOCALIZAÇÃO (MAPA) */}
      <section id="location" className="location">
        <h2>Localização</h2>
        <div className="maps-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.233544904686!2d-8.245672224116902!3d41.282021371313306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2493633e910a19%3A0xf7afcb5744df18cf!2sMeicor%20-%20Passamanarias%2C%20Lda.!5e0!3m2!1spt-PT!2spt!4v1743025435995!5m2!1spt-PT!2spt"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mapa da Meicor"
          />
        </div>
      </section>

      {/* FOOTER */}
      <Footer></Footer>
    </div>
  );
};

export default HomePage;
